import React from 'react'
import logo from './logosm.jpg'

const Footer = () => (
  <footer>
    <div id="footer-content">
      <ul id="navigation-footer">
        <li className="page_item page-item-4">
          <a href="http://gomezandassociates.com/">Who We Are</a>
        </li>
        <li className="page_item page-item-121">
          <a href="http://gomezandassociates.com/what-we-do">What We Do</a>
        </li>
        <li className="page_item page-item-19">
          <a href="http://gomezandassociates.com/our-clients">Our Clients</a>
        </li>
        <li className="page_item page-item-21">
          <a href="http://gomezandassociates.com/work-projects">
            Work Projects
          </a>
        </li>
        <li className="page_item page-item-23 current_page_ancestor current_page_parent">
          <a href="http://gomezandassociates.com/our-associates">
            Our Associates
          </a>
        </li>
        <li className="page_item page-item-15">
          <a href="http://gomezandassociates.com/contact-us">Contact Us</a>
        </li>
      </ul>

      <div id="footer-contact">
        <img
          className="float-left"
          src={logo}
          height="55"
          alt="Gómez &amp; Associates Logo"
        />
        <ul id="footer-contact-info">
          <li>14 E. Jefferson Street,</li>
          <li>Colorado Springs,</li>
          <li>CO 80907</li>
          <li>719.447.4841 (O)</li>
          <li>719.659.0808 (M)</li>
          <li>
            <a className="white" href="mailto:info@gomezandassociates.com">
              info@gomezandassociates.com
            </a>
          </li>
        </ul>
      </div>
      <div id="bottom-statement">
        Gómez &amp; Associates - The Leading Edge for Executive Teams
      </div>
    </div>
  </footer>
)
export default Footer
